import processSale from "../saved_payment_method/processSale"
import validatePaymentMethod from "../saved_payment_method/validatePaymentMethod"
import ConfirmationScreenDetails from "./ConfirmationScreenDetails"

export const DockwaPay = {
  ConfirmationScreenDetails,
  processSale,
  validatePaymentMethod,
  showTipInput: true,
  paymentFlowName: "Dockwa Pay",
}
